import React from "react";
import { Modal } from "antd";

export const PopupModal = ({ 
  isOpen, 
  onClose, 
  title, 
  subTitle,
  isSuccess = true,
  buttons = []  // Array of button configurations
}) => {
  return (
    <Modal
      centered
      open={isOpen}
      destroyOnClose={true}
      closable={false}
      footer={null}
      onCancel={onClose}
      width={window.innerWidth <= 768 ? '95vw' : 520}
      className="responsive-popup-modal"
      bodyStyle={{
        padding: window.innerWidth <= 480 ? 15 : 24
      }}
    >
      <div className="p-5">
        <div className="success-modal" style={{ textAlign: 'center' }}>
          <i
            className={`bi ${isSuccess ? 'bi-check-circle-fill text-success' : 'bi-x-circle-fill text-danger'}`}
            style={{ fontSize: "4rem" }}
          />
          <p className="lead mt-4">{title}</p>
          <p className="text-black-50">{subTitle}</p>
          
          <div className="d-flex gap-3 justify-content-center mt-4 flex-wrap">
            {/* Default close button if no custom buttons provided */}
            {buttons.length === 0 && (
              <button
                className={`btn ${isSuccess ? 'btn-primary' : 'btn-primary'} w-75`}
                onClick={onClose}
              >
                Close
              </button>
            )}
            
            {/* Render custom buttons */}
            {buttons.map((button, index) => (
              <button
                key={index}
                className={`btn ${button.className || (isSuccess ? 'btn-primary' : 'btn-primary')} flex-grow-1 mobile-full-width`}
                onClick={button.onClick}
                disabled={button.disabled}
                style={button.style}
              >
                {button.icon && <i className={`bi ${button.icon} me-2`} />}
                {button.text}
              </button>
            ))}
          </div>
        </div>
      </div>
    </Modal>
  );
};
